import { render, staticRenderFns } from "./match-frequency.vue?vue&type=template&id=71fc8b45&scoped=true&"
import script from "./match-frequency.vue?vue&type=script&lang=js&"
export * from "./match-frequency.vue?vue&type=script&lang=js&"
import style0 from "./match-frequency.vue?vue&type=style&index=0&id=71fc8b45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fc8b45",
  null
  
)

export default component.exports